type IndexedEntity = {
  indices: [number, number]
}

export const concatMentionsToEntities = <Entity extends IndexedEntity>(
  mentions: Entity[] | null | undefined,
  entities: Entity[],
): Entity[] => {
  if (mentions) {
    return entities.concat(mentions).toSorted((a, b) => {
      if (a !== null && b !== null) return a.indices[0] - b.indices[0]
      return 0
    })
  }

  return entities
}

export interface MentionEntity {
  displayString: string
  indices: [number, number]
  rawString: string
  className?: string
  url?: string
}

export * from './facebook/helpers'
export * from './googlebusiness/helpers'
export * from './instagram/helpers'
export * from './linkedin/helpers'
export * from './mastodon/helpers'
export * from './tiktok/helpers'
export * from './twitter/helpers'
export * from './youtube/helpers'
